export default {
	tableHeaders: {
		database: {
			name: 'Name',
			shortName: 'Short name',
			alias: 'Alias',
			baseType: 'Base type',
			comment: 'Comment',
			server: 'Server'
		},
		app: {
			name: 'Name',
			alias: 'Alias',
			apiType: 'API type',
			path: 'Path',
			server: 'Server',
			isWebApp: 'Is web?',
			yes: 'yes',
			no: 'no'
		},
		server: {
			name: 'Name',
			serverType: 'Server type',
			httpPath: 'HTTP path',
			host: 'Host',
			path: 'Path',
			isTiny: 'Tiny'
		},
		user: {
			login: 'Login',
			password: 'Password',
			fullName: 'Full name',
			datePassword: 'Password date',
			dateBegin: 'Start date',
			dateEnd: 'Finish date',
			role: 'Role',
			status: 'Status',
			statusDisabled: 'disabled',
			statusEnabled: 'enabled'
		},
		role: {
			id: 'ID',
			name: 'Name',
			type: 'Role type'
		},
		appParam: {
			id: 'ID',
			name: 'Name'
		},
		upgrades: {
			idVersion: "ID version",
			datecurr: "Install date"
		},
		process: {
			app: 'App',
			db: 'Database',
			lstart: 'Start time',
			etime: 'Working time',
			pcpu: 'CPU load',
			ip: 'IP',
			user: 'User'
		},
		service: {
			s: 'Service',
			p: 'Params',
			st: 'Status',
			dst: 'Additional status'
		},
		statusTask: {
			id: '№',
			pidTask: 'pid',
			nameTask: 'Name',
			paramsTask: 'Params',
			nameServer: 'Server',
			qDateBegin: 'Started',
			qDateEnd: 'Finished',
			nameUser: 'User',
			comment: 'Comment'
		},
		task: {
			id: 'ID',
			caption: 'Caption',
			path: 'Path',
			isPacketable: 'Is packetable',
			idTypeTask: 'Type task',
			comment: 'Comment'
		}
	}
};
